import Loading from "Components/Global/Loading";

import SplashScreen from "../SplashScreen";
import * as S from "./styles";

const GlobalLoading = ({ render }) => {
  return (
    <>
      {render ? (
        <SplashScreen />
      ) : (
        <S.LoadingWrapper className="loading">
          <Loading />
        </S.LoadingWrapper>
      )}
    </>
  );
};

export default GlobalLoading;
